import Cookies from 'js-cookie'
import { EnumCookieKeys } from '_constants'

const retrieve = (name: EnumCookieKeys) => {
  return Cookies.get(name)
}

const retrieveJSON = <TReturn>(name: EnumCookieKeys): TReturn | undefined => {
  return Cookies.getJSON(name)
}

const store = (
  name: EnumCookieKeys,
  value: string | Record<string, unknown>,
  options?: Cookies.CookieAttributes
) => {
  return Cookies.set(name, value, options)
}

const clear = (name: EnumCookieKeys) => {
  return Cookies.remove(name)
}

const cookieStorage = { store, retrieve, retrieveJSON, clear }
export default cookieStorage
